module.exports = __webpack_public_path__ + "static/media/Safe-T19.936c5c0e.jpg";